import React from "react";
import { motion } from "framer-motion";

const Achievements = ({ achievements }) => {
  if (!achievements?.length) return null;

  return (
    <section id="numbers" className="py-24 md:py-32 border-t border-white/10" data-testid="achievements-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4">CHAPTER 0X — THE EVIDENCE</p>
        <h2 className="font-display text-3xl md:text-4xl text-gray-100 mb-16">
          A career measured in <span className="italic text-emerald-400">numbers, not adjectives.</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {achievements.map((a, i) => (
            <motion.div
              key={a.id}
              className="group bg-[#0a0a0a] p-8 md:p-10 hover:bg-[#0d0d0d] transition-colors"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: (i % 3) * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
              data-testid={`achievement-card-${a.id}`}
            >
              <p className="font-mono text-4xl md:text-5xl text-emerald-400 mb-3">{a.value}</p>
              <p className="font-mono text-xs tracking-widest uppercase text-gray-100 mb-4">{a.label}</p>
              <p className="text-sm text-gray-500 leading-relaxed group-hover:text-gray-400 transition-colors">{a.detail}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
